import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationControlsProps {
  page: number
  totalPages: number
  total: number
  label: string
  onPrevious: () => void
  onNext: () => void
}

export function PaginationControls({
  page,
  totalPages,
  total,
  label,
  onPrevious,
  onNext,
}: PaginationControlsProps) {
  if (totalPages <= 1) return null

  return (
    <div className="flex items-center justify-between">
      <p className="font-mono text-[11px] text-ink-faint">
        Page {page} of {totalPages} ({total} {label})
      </p>
      <div className="flex items-center gap-1">
        <button
          type="button"
          disabled={page <= 1}
          onClick={onPrevious}
          className="rounded-md border border-dashed border-border bg-surface p-1.5 text-ink-muted transition-colors hover:bg-surface-alt disabled:opacity-40"
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </button>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={onNext}
          className="rounded-md border border-dashed border-border bg-surface p-1.5 text-ink-muted transition-colors hover:bg-surface-alt disabled:opacity-40"
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
